import React, { useState, useEffect, useRef } from 'react';
import './MenuItem.css';
import {
    Box,
    Modal,
    Grid,
    RadioGroup,
    FormControlLabel,
    Radio,
    Dialog,
    DialogTitle,
    DialogContent,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import filterIcon from '../../../assets/Filtericon.png';
import greenDot from '../../../assets/greendot.svg';
import redDot from '../../../assets/reddot.svg';
import image1 from '../../../assets/Image1.png';
import { useTranslation } from 'react-i18next';
import FoodMenuDetailsModal from '../Search/FoodMenuDetailsModal';
import axiosVendorInstance from '../../../axiosVendorInstance';
import { useNavigate } from 'react-router-dom';
import BackArrow from '../../../assets/svg/BackArrow';
import { IoPlayOutline } from 'react-icons/io5';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BusinessHoursModel from './BusinessHoursModel';
import OrderPopop from '../../../Components/OrderPopop';

const MenuItem = ({ restaurantData, searchQuery, isNavigate, id }) => {
    const isDesktop = useMediaQuery('(min-width:601px)'); 
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [animateModal, setAnimateModal] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState('Relevance');
    const [filteredMenus, setFilteredMenus] = useState([]);
    const [selectedMenuName, setSelectedMenuName] = useState(null);
    const [allMenuItems, setAllMenuItems] = useState([]);
    const [selectedFood, setSelectedFood] = useState(null);
    const [openFoodDetail, setOpenFoodDetail] = useState(false);
    const navigate = useNavigate();
    const videoRefs = useRef({});
    const [playingIndex, setPlayingIndex] = useState(null);
    const [showBusinessPopup, setShowBusinessPopup] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [vendorId, setVendorId] = useState(null);
    const [restaurantName, setRestaurantName] = useState(null);
    const [vendorRating, setVendorRating] = useState(null);
    const [vendorAddress, setVendorAddress] = useState(null);
    const [vendorDistance, setVendorDistance] = useState(null);

    const handlePlay = (e, index) => {
        e.stopPropagation();
            
        Object.entries(videoRefs.current).forEach(([key, video]) => {
            if (parseInt(key) !== index && video && !video.paused) {
                video.pause();
            }
        });
            
        const currentVideo = videoRefs.current[index];
        if (currentVideo) {
            currentVideo.play();
            setPlayingIndex(index);
        }
    };


    const handleClose = () => {
        setOpenFoodDetail(false);
        setSelectedFood(null);
    };

    // Handle filter change
    const handleFilterChange = (event) => {
        setSelectedFilter(event.target.value);
        handleFilterPopupClose(); 
    };
    
    const handleOpen = () => {
        setOpen(true);
    };

    const handleFilterPopupClose = () => {
        setOpen(false);
    };

    const handleDashboardNavigate = () =>{
        navigate('/dashboard');
    };

    const fetchFoodDetails = async (itemId,vendorDistance, isVideoPlaying = false) => {
        try {
            const response = await axiosVendorInstance.get(
                `/vendors/menuitems/particularitem/${itemId}`, {skipAuth: true}
            );
            
            const item = response?.data?.menuItem;

            setSelectedFood({
                ...item,
                autoplay: isVideoPlaying
            });    

            setRestaurantName(response?.data?.menuItem?.VendorName);
            setVendorId(response?.data?.menuItem?.VendorID);
            setVendorRating(response?.data?.menuItem?.VendorAvgRating);
            setVendorAddress(response?.data?.menuItem?.VendorAddress);
            setVendorDistance(vendorDistance);
            setOpenFoodDetail(true);
        } catch (error) {
            console.error('Error fetching offer details:', error);
        }
    };

    useEffect(() => {
        if (!restaurantData?.vendor?.vendorMenus) return;

        const items = restaurantData.vendor.vendorMenus.flatMap(menu => 
            menu.menu_items.map(item => ({
                ...item,
                menuName: menu.Menu_name
            }))
        );
        
        setAllMenuItems(items);
    }, [restaurantData]);

    // Apply both filters (type filter and menu name filter)
    useEffect(() => {
        if (!allMenuItems.length) return;
    
        let filteredItems = [...allMenuItems];
    
        // Apply search filter
        if (searchQuery) {
            const lowerCaseQuery = searchQuery.toLowerCase();
            filteredItems = filteredItems.filter(item => 
                item.Item_name.toLowerCase().includes(lowerCaseQuery) ||  // Search by Item Name
                (item.Description && item.Description.toLowerCase().includes(lowerCaseQuery)) || // Search by Description
                item.menuName.toLowerCase().includes(lowerCaseQuery)  // Search by Menu Name
            );
        }
    
        // Apply menu selection filter
        if (selectedMenuName) {
            filteredItems = filteredItems.filter(item => item.menuName === selectedMenuName);
        }
    
        // Apply sorting & dietary filters
        switch (selectedFilter) {
        case 'Pure Veg':
            filteredItems = filteredItems.filter(item => item.Vegetarian === true);
            break;
        case 'Pure Non-Veg':
            filteredItems = filteredItems.filter(item => item.Vegetarian === false);
            break;
        case 'priceLowToHigh':
            filteredItems.sort((a, b) => parseFloat(a.Price) - parseFloat(b.Price));
            break;
        case 'priceHighToLow':
            filteredItems.sort((a, b) => parseFloat(b.Price) - parseFloat(a.Price));
            break;
        default:
            break;
        }
    
        // Convert filtered items back into menu structure
        const groupedMenus = restaurantData?.vendor?.vendorMenus
            ?.map(menu => ({
                ...menu,
                menu_items: filteredItems?.filter(item => item?.menuName === menu?.Menu_name),
            }))
            .filter(menu => menu?.menu_items?.length > 0);
    
        setFilteredMenus(groupedMenus);
    }, [selectedFilter, selectedMenuName, allMenuItems, searchQuery]);
    

    setTimeout(() => {
        setAnimateModal(true);
    }, 100);

    const menuNames = restaurantData?.vendor?.vendorMenus 
        ? restaurantData?.vendor?.vendorMenus?.map(menu => menu?.Menu_name)
            .sort((a, b) => b.localeCompare(a))
        : [];

    const handleOrderClick = () => {  
        setOpenPopup(!openPopup);
    };

    return (
        <div className='menu-main-container'>
            <div className="filters-scroll">
                <div className="filters">
                    {isNavigate &&<div className="restaurant-common-filter">
                        <BackArrow className='back-btn12' onClick={() =>handleDashboardNavigate()}/>
                    </div>}
                    <div className="menu-name-filters">
                        {menuNames?.map((menuName, index) => (
                            <p
                                key={index}
                                className={`bg-css ${selectedMenuName === menuName ? 'active-filter' : ''}`}
                                onClick={() => setSelectedMenuName(prev => (prev === menuName ? null : menuName))}
                            >
                                {menuName}
                            </p>

                        ))}
                    </div>
                    <div className="filter-div">
                        <p className='bg-css'
                            onClick={handleOpen}
                        >
                            <img src={filterIcon} alt="filter-icon" className='filter-icon' />
                            {!isMobile ? 'Filter' : ''}
                        </p>
                        
                        <AccessTimeIcon onClick={() => setShowBusinessPopup(true)} className='hours-icon'/>
                    </div>
                </div>
            </div>
            
            {/* Mobile Modal */}
            {!isDesktop && (
                <Modal open={open} onClose={handleFilterPopupClose}>
                    <Box className={`style1 ${animateModal ? 'animate' : ''}`}>
                        <h2 className='filter-title'>{t('homescreen.filter-title')}</h2>
                        <Grid container spacing={2} className="width-of-dialog-box">
                            <Grid item xs={isMobile ? 6 : 7}>
                                <div className="css-mhc70k-MuiGrid-root MuiGrid-item">
                                    <RadioGroup value={selectedFilter} onChange={handleFilterChange}>
                                        <FormControlLabel 
                                            value="Relevance"
                                            control={<Radio />}
                                            label={t('homescreen.sort-by-tab-val1')} />
                                        <FormControlLabel
                                            value="priceLowToHigh"
                                            control={<Radio />}
                                            label={t('homescreen.sort-by-tab-val4')} />
                                        <FormControlLabel
                                            value="priceHighToLow"
                                            control={<Radio />}
                                            label={t('homescreen.sort-by-tab-val5')} />
                                        <FormControlLabel
                                            value="Pure Veg"
                                            control={<Radio />}
                                            label={t('homescreen.veg')} />
                                        <FormControlLabel
                                            value="Pure Non-Veg"
                                            control={<Radio />}
                                            label={t('homescreen.nonveg')} />
                                        <FormControlLabel
                                            value="Veg and Non-Veg"
                                            control={<Radio />}
                                            label={t('homescreen.veg-or-nonveg-tab-val3')} />
                                    </RadioGroup>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            )}

            {/* Desktop Dialog */}
            {isDesktop && (
                <Dialog open={open} onClose={handleFilterPopupClose} width="70%" height="300px" >
                    <DialogTitle className="filters-title">
                        {t('homescreen.filter-title')}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} className="width-of-dialog-box">
                            <Grid item xs={isMobile ? 6 : 7}>
                                <div className="css-mhc70k-MuiGrid-root MuiGrid-item">
                                    <RadioGroup value={selectedFilter} onChange={handleFilterChange}>
                                        <FormControlLabel
                                            value="Relevance"
                                            control={<Radio />}
                                            label={t('homescreen.sort-by-tab-val1')} />
                                        <FormControlLabel
                                            value="priceLowToHigh"
                                            control={<Radio />}
                                            label={t('homescreen.sort-by-tab-val4')} />
                                        <FormControlLabel
                                            value="priceHighToLow"
                                            control={<Radio />}
                                            label={t('homescreen.sort-by-tab-val5')} />
                                        <FormControlLabel
                                            value="Pure Veg"
                                            control={<Radio />}
                                            label={t('homescreen.veg')} />
                                        <FormControlLabel
                                            value="Pure Non-Veg"
                                            control={<Radio />}
                                            label={t('homescreen.nonveg')} />
                                        <FormControlLabel
                                            value="Veg and Non-Veg"
                                            control={<Radio />}
                                            label={t('homescreen.veg-or-nonveg-tab-val3')} />
                                    </RadioGroup>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            )}
            
            {/* Display menu items with applied filters */}
            <div className={`all-menu-item ${!isNavigate ? 'all-without-item' : '' }`} >
                {restaurantData && filteredMenus?.length > 0 ? filteredMenus?.map((menuname) => (
                    <div key={menuname?.ID} className='menu-bottom-container menu-item1'>
                        <h3 className='menu-starter-text'>
                            {menuname?.Menu_name.toUpperCase()}
                        </h3>
                        <div className='menu-starter-container'>
                            {menuname?.menu_items?.map((item) => (
                                <div 
                                    key={item.ID} 
                                    className='menu-item' 
                                    onClick={() => fetchFoodDetails(item?.ID, vendorDistance, playingIndex === item?.ID)}
                                >
                                    <div className="restaurant-media-wrapper">
                                        {item.Avatar_key?.match(/\.(mp4|webm|ogg)$/i) ? (
                                            <div className="restaurant-video-container1"
                                                onClick={() => fetchFoodDetails(item?.ID, vendorDistance, playingIndex === item?.ID)}    
                                            >
                                                <video
                                                    src={item?.Avatar_key}
                                                    muted
                                                    playsInline
                                                    // eslint-disable-next-line react/no-unknown-property
                                                    webkit-playsinline='true'
                                                    preload="metadata"
                                                    className="restaurant-food-video"
                                                    ref={(el) => (videoRefs.current[item?.ID] = el)}
                                                    onClick={(e) => {
                                                        const rect = e.currentTarget.getBoundingClientRect();
                                                        const clickX = e.clientX - rect.left;
                                                        const clickY = e.clientY - rect.top;
                                                        const centerX = rect.width / 2;
                                                        const centerY = rect.height / 2;
                                                        const radius = Math.min(rect.width, rect.height) * 0.2;

                                                        const distanceFromCenter = Math.hypot(clickX - centerX, clickY - centerY);

                                                        if (distanceFromCenter < radius) {
                                                            e.stopPropagation();
                                                            const video = videoRefs.current[item?.ID];
                                                            if (video) {
                                                                if (video.paused) {
                                                                    video.play();
                                                                    setPlayingIndex(item?.ID);
                                                                } else {
                                                                    video.pause();
                                                                    setPlayingIndex(null);
                                                                }
                                                            }
                                                        } else {
                                                            fetchFoodDetails(item?.ID, vendorDistance, playingIndex === item?.ID);
                                                        }
                                                    }}
                                                    onEnded={() => setPlayingIndex(null)}
                                                />
                                                {playingIndex !== item?.ID && (
                                                    <button onClick={(e) => handlePlay(e, item?.ID)} className='play-btn'>
                                                        <IoPlayOutline color='white' fontSize={34} />
                                                    </button>
                                                )}

                                            </div>
                                        ) : (
                                            <img
                                                className='restaurant-Food-image'
                                                src={item?.Avatar_key || image1}
                                                alt='Food img'
                                                onError={(e) => {
                                                    e.target.src = image1;
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className='menu-description-container'>
                                        <div className='heading-container'>
                                            <img className="item-reddot-order" src={item?.Vegetarian === true ? greenDot : item?.Vegetarian === false ? redDot : ''} alt="dot" />
                                            <h3 className='menu-item-head-text'>
                                                {item?.Item_name}
                                            </h3>
                                        </div>
                                        <p className='menu-description' dangerouslySetInnerHTML={{ __html: item?.Description.length > 100 
                                            ? item?.Description.slice(0, 100) + '...' 
                                            : item?.Description }} />
                                        <div className='menu-item-bottom-container'>
                                            <h6 className='menu-item-price-text'>${item?.Price}</h6>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )) :  restaurantData ? (
                    <p className='no-item-found'>No Items Found</p>
                ) : null}
            </div>

            {selectedFood && (
                <FoodMenuDetailsModal
                    open={openFoodDetail}
                    handleClose={handleClose}
                    food={selectedFood}
                    handleOrderClick={handleOrderClick}
                    rating={vendorRating}
                    orderBtn={false}
                />
            )}

            <div>
                {openPopup && 
                    <OrderPopop
                        restaurantName={restaurantName}
                        handleClose={()=> {
                            setTimeout(() => {
                                setOpenPopup(!openPopup);
                            }, 500);
                        }}
                        vendorID={vendorId}
                        rating={vendorRating}
                        vendorAddress={vendorAddress}
                        vendorDistance={vendorDistance}
                    />
                }
            </div>

            {showBusinessPopup && <BusinessHoursModel open={showBusinessPopup} onClose={() => setShowBusinessPopup(false)} id={id}/>}
        </div>
    );
};

export default MenuItem;